<template>
<div>
  <el-dialog
      title="Upload from CSV"
      :visible.sync="upload_visible"
  >
    <el-upload
        id="data_file"
        drag
        :on-success="afterSuccessfulUpload"
        :on-remove="afterRemove"
        action="/api/uploads">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
    </el-upload>
    <el-button type="primary" v-on:click="startImport" id="data_start" >Load CSV</el-button>
  </el-dialog>
  <h1>Category On Field: {{set.match_field}}</h1>
  <h2>Category FieldSet Name: {{set.name}}</h2>
  <h2>Category Fields:</h2>
  <ul>
    <li v-for="field in set.fields">{{field}}</li>
  </ul>
  <p>Category Field Sets are normally edited in a custom table, where a blend of metadata can be brought to bear in filling out the category values. That said, you cana upload a CSV from here as well.</p>
  <el-button style="margin-bottom:20px;" @click="show_upload">Upload CSV</el-button>
  <h2>Upload results:</h2>
  {{results.counts}}
  <p><strong>NEW (possibly where there is no corresponding Site Title):</strong></p>
  <ul>
    <li v-for="new_item in results.new_list">{{new_item}}</li>
  </ul>

</div>
</template>

<script>
export default {
  name: "CategoryFieldSet",
  props: ['set_id','extent_id'],
  data() {
    return {
      set: {},
      have_data: false,
      upload_visible: false,
      results: {},
      form: {
        upload_file: ''
      },
    }
  },
  mounted() {
    axios.get('/api/category/' + this.extent_id + '/' + this.set_id)
        .then(response => {
          this.set = response.data
          this.have_data = true
        })
        .catch(error => {
          console.log('could not load set')
        })
    console.log('TESTING')
    console.log(this.set.match_field)
  },
  methods: {
    show_upload() {
      this.upload_visible = true
    },
    startImport() {
      axios.post('/api/category/' + this.extent_id + '/' +  this.set_id, {
        upload_file: this.form.upload_file
      }).then(response => {
        this.results = response.data
        this.upload_visible = false
      }).catch(error => {
        console.log('oops problem starting import')
        console.log(error.response)
      })
      //
    },
    afterSuccessfulUpload(response) {
      this.form.upload_file = response
    },
    afterRemove() {
      this.form.upload_file = ''
    },
  }
}
</script>

<style scoped>

</style>